import React, { useEffect, useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';

import Appearance from 'styles/Appearance';
import Utils from 'files/Utils.js';

const Alert = ({ buttons, component, icon, id, index, message, onClick, onClose, title }) => {

    const ref = useRef(null);
    const [animations, setAnimations] = useSpring(() => ({
        opacity: 0,
        transform: 'scale(0)',
        config: { mass: 1, tension: 180, friction: 16 }
    }));
    const [visible, setVisible] = useState(false);

    const onButtonClick = async key => {
        try {
            await onHideAlert(key);
            if(typeof(onClick) === 'function') {
                onClick(key);
            }
        } catch(e) {
            console.error(e.message);
        }
    }

    const onHideAlert = async key => {
        return new Promise(async (resolve, reject) => {
            try {
                setAnimations({
                    opacity: 0,
                    transform: 'scale(0)'
                });
                await Utils.sleep(0.25);
                if(typeof(onClose) === 'function') {
                    onClose(id, key);
                }
                resolve();
            } catch(e) {
                reject(e);
            }
        });
    }

    const onShowAlert = () => {
        let interval = setInterval(() => {
            if(!ref.current) {
                return;
            }
            clearInterval(interval);
            setAnimations({
                opacity: index === 0 ? 1 : 0,
                transform: `scale(${index > 3 ? 0 : 1 - (index / 4)})`
            });
        }, 250);
    }

    const getButtons = () => {
        if(buttons === false) {
            return [];
        }
        let targets = buttons || [];
        if(targets.length === 0) {
            targets.push({
                key: 'cancel',
                title: 'Okay',
                style: 'cancel'
            });
        }
        return targets;
    }

    const getButtonColor = style => {
        switch(style) {
            case 'default':
            return window.theme === 'dark' ? 'white' : Appearance.colors.primary()

            case 'destructive':
            return Appearance.colors.red;

            default:
            return Appearance.colors.text();
        }
    }

    const getContent = () => {
        if(visible === false) {
            return null;
        }
        return (
            <animated.div
            ref={ref}
            style={{
                alignItems: 'center',
                backgroundColor: Appearance.colors.transparent,
                display: 'flex',
                height: '100%',
                justifyContent: 'center',
                left: 0,
                opacity: animations.opacity,
                position: 'fixed',
                top: 0,
                width: '100%',
                zIndex: 9950
            }}>
                <animated.div style={{
                    alignItems: 'center',
                    backgroundColor: Appearance.colors.alert(),
                    borderRadius: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow:'hidden',
                    maxHeight: 'calc(100vh - 30px)',
                    maxWidth: 350,
                    textAlign: 'center',
                    width: '100%',
                    zIndex: 9999,
                    ...animations
                }}>
                    {icon && icon.path && (
                        <div style={{
                            borderRadius: 15,
                            boxShadow: window.theme === 'dark' ? '3px 3px 7px rgba(0,0,0,0.15), -3px -3px 7px rgba(174,174,174,0.1)' : '3px 3px 7px #c9c8ca, -3px -3px 7px #ffffff',
                            height: 75,
                            marginTop: 20,
                            overflow: 'hidden',
                            width: 75,
                            ...icon.style
                        }}>
                            <img
                            src={icon.path}
                            style={{
                                height: '100%',
                                resizeMode: 'contain',
                                width: '100%'
                            }}/>
                        </div>
                    )}
                    <span style={{
                        display: 'block',
                        color: Appearance.colors.text(),
                        fontSize: 18,
                        fontWeight: '800',
                        lineHeight: 1.5,
                        marginBottom: 8,
                        paddingTop: icon ? 8:15,
                        paddingLeft: 15,
                        paddingRight: 15,
                    }}>{title}</span>

                    <div style={{
                        marginBottom: 24,
                        maxHeight: 500,
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                        maxWidth: '100%'
                    }}>
                        <span style={{
                            display: 'block',
                            maxWidth: '100%',
                            color: Appearance.colors.subText(),
                            fontSize: 13,
                            fontWeight: '500',
                            paddingLeft: 15,
                            paddingRight: 15,
                            wordWrap: 'break-word'
                        }}>{message}</span>
                    </div>
                    {component}
                    {getButtons().map((button, index) => {
                        return (
                            <div
                            key={index}
                            className={`alert-item ${window.theme}`}
                            onClick={onButtonClick.bind(this, button.key)}
                            style={{
                                height: 50,
                                width: '100%'
                            }}>
                                <div style={{
                                    height: 50
                                }}>
                                    <div style={{
                                        backgroundColor: Appearance.colors.divider(),
                                        height: 1,
                                        width: '100%'
                                    }}/>
                                    <div style={{
                                        alignItems: 'center',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        height: 50
                                    }}>
                                        <span style={{
                                             color: (button.style == 'cancel' || button.style == 'destructive') ? Appearance.colors.text() : Appearance.colors.primary(),
                                             fontSize: 13,
                                             fontWeight: '400',
                                             textAlign:'center',
                                        }}>{button.title}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </animated.div>
            </animated.div>
        )
    }

    useEffect(() => {
        setVisible(true);
        onShowAlert();
    }, [index]);

    return getContent();
}

export default Alert;
